import { makeAutoObservable } from "mobx";

export interface Category {
	id: string;
	name: string;
	markup: number;
	glCode?: string;
	deptGLCode?: string;
	businessGLCode?: string;
	isActive?: boolean;
}

export class CategoryModel implements Category {
	readonly id: string = '';
	name: string = '';
	markup: number = 0;
	glCode?: string;
	deptGLCode?: string;
	businessGLCode?: string;
	isActive: boolean = true;

	constructor(category: Category) {
		Object.assign(this, { isActive: true, ...category });
		makeAutoObservable(this);
	}

	get canSave() {
		return Boolean(this.name.trim() && this.markup <= 100 && this.markup >= 0);
	}

	// updating multiple properties at once
	update = (updates: Partial<Category>) => {
		Object.assign(this, updates);
	};
}
